<ng-content select="a3l-layout-sidenav"></ng-content>
<section class="a3l-layout-content">
  <ng-content></ng-content>
</section>
